import React, { ChangeEvent, FC } from "react";

import { Button } from "@/components/atoms/buttons/Button";
import { ButtonWithIcon } from "@/components/atoms/buttons/ButtonWithIcon";
import SearchField from "@/components/atoms/inputForms/SearchField";

import PlusIcon from "/public/icon/plus.svg";

interface Props {
  handleOnChangeInput: (
    ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  value?: string;
  placeholder?: string;
  spRows?: number;
  handleOpenSearchModal: () => void;
  handleSubmit: () => Promise<void>;
  handleAllServicesShow?: () => Promise<void>;
}

export const SpKeywordSearch: FC<Props> = ({
  handleOnChangeInput,
  value,
  placeholder = "キーワード検索",
  spRows = 1,
  handleSubmit,
  handleOpenSearchModal,
  handleAllServicesShow,
}) => {
  return (
    <div className="block md:hidden">
      <SearchField
        value={value ?? ""}
        onChange={handleOnChangeInput}
        placeholder={placeholder}
        className="w-full"
        spRows={spRows}
      />
      <ul className="flex justify-between items-center mt-2">
        <li>
          <ButtonWithIcon
            label="詳細検索"
            color="transparent"
            onClick={handleOpenSearchModal}
            icon={<PlusIcon className="w-3.5 h-3.5 fill-theme" />}
          />
        </li>
        {handleAllServicesShow && (
          <li className="basis-[110px] -mr-12">
            <Button
              type="button"
              color="cancel"
              size="md-fix"
              label="全てを表示"
              onClick={handleAllServicesShow}
            />
          </li>
        )}
        <li className="basis-[78px]">
          <Button
            type="button"
            color="primary"
            size="md-fix"
            label="検索"
            onClick={handleSubmit}
          />
        </li>
      </ul>
    </div>
  );
};
